import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectOption } from '../searchableSelect/searchableSelectTypes';
import { useTask } from '../../context/TaskContext';
import { TasksPriority } from '../../constants/tasks';
import { ITask } from '../../interface/tasks';

const PRIORITIES = [TasksPriority.high, TasksPriority.low, TasksPriority.normal];

/** The props `SearchableSelect` needs to pick a task's priority from its fixed levels. */
export const useTaskPrioritySelect = () => {
  const { t } = useTranslation();
  const { task, updateTask } = useTask();
  const [searchValue, setSearchValue] = useState('');

  const toOption = (priority: string): SelectOption => ({
    value: priority,
    label: t(`task:priorityLevel.${priority}`),
  });

  const searchTerm = searchValue.trim().toLowerCase();
  const options: SelectOption[] = PRIORITIES.map(toOption).filter(({ label }) =>
    label.toLowerCase().includes(searchTerm),
  );
  const value: SelectOption | null = task?.priority ? toOption(task.priority) : null;

  const onChange = (option: SelectOption) => {
    updateTask({ ...task, priority: option.value } as ITask);
  };

  return { options, value, onChange, onSearch: setSearchValue };
};
